import emojis from '@/utils/emojis';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import Image from 'next/image';

interface Props {
    state: boolean;
    setVisible: React.Dispatch<boolean>;
    insert: (code: string) => void;
}

const PANEL_BG = 'rgba(20,22,28,0.96)';

const EmojiPick = ({ state, setVisible, insert }: Props) => {
    return (
        <Popover
            isOpen={state}
            positions={['top']}
            padding={10}
            reposition
            onClickOutside={() => setVisible(false)}
            content={({ position, childRect, popoverRect }) => (
                <ArrowContainer
                    position={position}
                    childRect={childRect}
                    popoverRect={popoverRect}
                    arrowColor={PANEL_BG}
                    arrowSize={7}
                    arrowStyle={{ opacity: 1 }}
                    className=""
                    arrowClassName=""
                >
                    <div
                        className="rounded-fl-md border border-stroke_strong p-3 grid gap-2 w-72 max-h-[280px] overflow-y-auto fluent-scrollbar"
                        style={{
                            background: PANEL_BG,
                            backdropFilter: 'blur(20px) saturate(140%)',
                            WebkitBackdropFilter: 'blur(20px) saturate(140%)',
                            boxShadow: '0 12px 32px rgba(0,0,0,0.55)',
                            gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                        }}
                    >
                        {emojis.map((emoji) => (
                            <button
                                key={emoji.code}
                                onClick={() => insert(emoji.code)}
                                className="w-8 h-8 grid place-items-center rounded-md hover:bg-layer_3 transition-colors cursor-pointer"
                                aria-label={emoji.code}
                            >
                                <Image
                                    width={24}
                                    height={24}
                                    src={emoji.url}
                                    alt=""
                                    draggable={false}
                                    className="pointer-events-none"
                                />
                            </button>
                        ))}
                    </div>
                </ArrowContainer>
            )}
        >
            <button
                onClick={() => setVisible(true)}
                aria-label="Emoji"
                className="w-8 h-8 grid place-items-center rounded-lg text-text_3 hover:bg-layer_3 hover:text-text_main transition-colors"
            >
                <svg
                    viewBox="0 0 24 24"
                    className="w-4 h-4 stroke-current fill-none [stroke-width:2] [stroke-linecap:round] [stroke-linejoin:round]"
                >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                    <circle cx="9" cy="10" r="0.6" fill="currentColor" />
                    <circle cx="15" cy="10" r="0.6" fill="currentColor" />
                </svg>
            </button>
        </Popover>
    );
};

export default EmojiPick;
